import { createDefaultGenerativeRegistry } from 'flare-generative-ui';
import { renderModeArtifactBlock } from './renderModeArtifactBlock.jsx';

// Preserve Xiaocai's existing renderer through the public registry, not a build alias.
const ARTIFACT_RENDERERS = [
  'requirement_draft', 'next_actions', 'risk_summary', 'shortlist_updated',
  'evaluation_report_ready', 'plan_block', 'canvas_state', 'canvas_revision', 'mode_switch_reason',
];

export function createCoreGenerativeRegistry() {
  const registry = createDefaultGenerativeRegistry();
  ARTIFACT_RENDERERS.forEach((key) => registry.register(key, renderModeArtifactBlock));
  registry.register('knowledge_search', () => null);
  registry.register('sourcing_candidates', () => null);
  return registry;
}

export default createCoreGenerativeRegistry;
